// Red Chilly's full menu — exact items pulled from redchillyspa.com
// Prices preserved verbatim.

export const ORDER_URL =
  "https://www.redchillysindiasstreetkitchen.com/rfybje5r/red-chillys--indias-street-kitchen-pittsburgh-15205/order-online";

export const CATEGORIES = [
  { id: "soups", name: "Soups", tagline: "Warm, slow-simmered openers" },
  { id: "veg-app", name: "Veg Appetizers", tagline: "Crisp, fiery street starters" },
  { id: "nonveg-app", name: "Non-Veg Appetizers", tagline: "Bold tandoor & sukka classics" },
  { id: "kids", name: "Kids Menu", tagline: "Little plates, big smiles" },
  { id: "clay-oven", name: "Clay Oven", tagline: "Charred over live coals" },
  { id: "breads", name: "Breads", tagline: "Fresh from the tandoor" },
  { id: "south-indian", name: "South Indian Delight", tagline: "Sambar-soaked comfort" },
  { id: "dosa", name: "Dosa", tagline: "Crispy rice crêpes, your way" },
  { id: "veg-main", name: "Veg Main Course", tagline: "Hand-pounded masalas" },
  { id: "nonveg-main", name: "Non-Veg Main Course", tagline: "Slow-cooked curries" },
  { id: "indo-chinese", name: "Indo Chinese", tagline: "Wok-tossed street fusion" },
  { id: "biryanis", name: "Biryanis", tagline: "The signature dum experience" },
  { id: "beverages", name: "Beverages", tagline: "Sips that cool the heat" },
  { id: "desserts", name: "Desserts", tagline: "Sweet endings, Indian style" },
];

export const DISHES = {
  soups: [
    { name: "Sweet Corn Soup", desc: "Veg / Chicken", price: "$6.99 / $7.99" },
    { name: "Hot & Sour", desc: "Veg / Chicken", price: "$6.99 / $7.99" },
    { name: "Cream Of Tomato", desc: "Roasted tomato, cream finish", price: "$6.99" },
    { name: "Tomato Rasam", desc: "South Indian peppered broth", price: "$5.99" },
    { name: "Manchow", desc: "Veg / Chicken with crispies", price: "$6.99 / $7.99" },
    { name: "Lentil Soup", desc: "Tempered yellow dal", price: "$5.99" },
  ],
  "veg-app": [
    { name: "Samosa (2 pcs)", desc: "Flaky pastry, spiced potato", price: "$7.99" },
    { name: "Masala Papad", desc: "Onion-tomato-chili topping", price: "$5.99" },
    { name: "Roasted Papad", desc: "Classic crispy lentil wafer", price: "$4.99" },
    { name: "Samosa Chat", desc: "Yogurt, chutneys, sev", price: "$10.99" },
    { name: "Aloo Tikki (3 pcs)", desc: "Pan-seared potato cakes", price: "$8.99" },
    { name: "Aloo Tikki Chat", desc: "Loaded chutney chaat", price: "$9.99" },
    { name: "Punugulu", desc: "Andhra-style fritters", price: "$10.99" },
    { name: "Cut Mirchi", desc: "Battered green chili, gram flour", price: "$8.99" },
    { name: "Stuffed Mirchi", desc: "Spiced potato filling", price: "$10.99" },
    { name: "Veg Manchurian", desc: "Indo-Chinese classic", price: "$14.99" },
    { name: "Pakora", desc: "Onion / Spinach / Mixveg", price: "$7.99 / $8.99 / $9.99" },
    { name: "Karapodi", desc: "Baby corn / Gobi / Paneer", price: "$14.99 / $15.99 / $16.99" },
    { name: "Curryleaf", desc: "Baby corn / Gobi / Paneer", price: "$14.99 / $15.99 / $16.99" },
    { name: "Manchurian", desc: "Baby corn / Gobi / Paneer", price: "$14.99 / $15.99 / $16.99" },
    { name: "65", desc: "Baby corn / Gobi / Paneer", price: "$14.99 / $15.99 / $16.99" },
    { name: "555", desc: "Baby corn / Gobi / Paneer", price: "$14.99 / $15.99 / $16.99" },
    { name: "Jalapeño Gobi", desc: "Cauliflower tossed in fresh jalapeño", price: "$16.99" },
  ],
  "nonveg-app": [
    { name: "Masala Omelette", desc: "Onion, chili, cilantro", price: "$7.99" },
    { name: "Egg Bhurji", desc: "Spiced scrambled eggs", price: "$11.99" },
    { name: "Manchurian", desc: "Chicken / Shrimp", price: "$16.99 / $19.99" },
    { name: "Chilli", desc: "Chicken / Shrimp", price: "$16.99 / $19.99" },
    { name: "555", desc: "Chicken / Shrimp", price: "$16.99 / $19.99" },
    { name: "65 (Wet)", desc: "Chicken / Shrimp", price: "$16.99 / $19.99" },
    { name: "Hyderabadi 65 (Dry)", desc: "Chicken / Shrimp", price: "$16.99 / $19.99" },
    { name: "Karapodi", desc: "Chicken / Fish / Shrimp", price: "$16.99 / $19.99 / $19.99" },
    { name: "Curryleaf", desc: "Chicken / Fish / Shrimp", price: "$15.99 / $19.99 / $19.99" },
    { name: "Pepper Fry", desc: "Chicken / Goat / Shrimp", price: "$16.99 / $18.99 / $19.99" },
    { name: "Chicken Lollipop (Dry)", desc: "Frenched drumettes", price: "$17.99" },
    { name: "Masala Lollipop (Wet)", desc: "Tossed in tangy masala", price: "$17.99" },
    { name: "Kaju Chicken Pakodi", desc: "Boneless, cashew crusted", price: "$17.99" },
    { name: "Jalapeño Chicken", desc: "Fresh jalapeño heat", price: "$17.99" },
    { name: "Ghee Roast", desc: "Goat / Lamb", price: "$18.99 / $19.99" },
    { name: "Goat Sukka", desc: "Dry Mangalorean roast", price: "$18.99" },
    { name: "Lamb Chilli Roast", desc: "Sliced lamb, chili & curry leaf", price: "$19.99" },
    { name: "Apollo Fish", desc: "Hyderabadi twice-cooked fish", price: "$19.99" },
    { name: "Andhra Fish Fry", desc: "Tilapia, coast-style spice", price: "$19.99" },
  ],
  kids: [
    { name: "French Fries", desc: "Crispy, lightly salted", price: "$4.99" },
    { name: "Chicken Nuggets with Fries", desc: "Kid-favourite combo", price: "$7.99" },
    { name: "Mozzarella Sticks with Fries", desc: "Golden & gooey", price: "$7.99" },
    { name: "Dosa", desc: "Chocolate / Cheese", price: "$9.99" },
  ],
  "clay-oven": [
    { name: "Paneer Tikka", desc: "Charred cottage cheese cubes", price: "$16.99" },
    { name: "Tandoori Chicken", desc: "Half / Full", price: "$16.99 / $19.99" },
    { name: "Chicken Tikka", desc: "Boneless, yogurt-marinated", price: "$16.99" },
    { name: "Chicken Malai Kebab", desc: "Cream & cardamom kissed", price: "$17.99" },
    { name: "Chicken Hariyali Kebab", desc: "Mint-coriander marinade", price: "$16.99" },
    { name: "Chicken Seekh", desc: "Hand-rolled spiced mince", price: "$17.99" },
    { name: "Lamb Seekh", desc: "Skewered & smoked", price: "$19.99" },
    { name: "Lamb Chops (4 pcs)", desc: "Slow-marinated, char-grilled", price: "$23.99" },
    { name: "Tandoori Shrimp", desc: "Tandoor-seared jumbo shrimp", price: "$19.99" },
    { name: "Fish Tikka Kebab", desc: "Tilapia, ajwain & lime", price: "$19.99" },
    { name: "Salmon Tikka", desc: "Atlantic salmon, tandoor finish", price: "$22.99" },
    { name: "Tandoori Fish", desc: "Whole pomfret, masala rubbed", price: "$23.99" },
    { name: "Mixed Grill", desc: "Chicken, Lamb & Shrimp", price: "$27.99" },
  ],
  breads: [
    { name: "Naan", desc: "Plain / Butter / Garlic", price: "$3.99 / $4.49 / $4.99" },
    { name: "Bullet / Onion Naan", desc: "Stuffed varieties", price: "$4.99" },
    { name: "Kashmiri Naan", desc: "Sweet nut & fruit stuffed", price: "$5.99" },
    { name: "Tandoori Roti", desc: "Whole wheat, tandoor-baked", price: "$4.99" },
    { name: "Paneer Kulcha", desc: "Stuffed with spiced cheese", price: "$5.99" },
    { name: "Chapatti (2 pcs)", desc: "Soft whole wheat flatbread", price: "$5.99" },
    { name: "Malabar Paratha (2 pcs)", desc: "Flaky South Indian layers", price: "$6.99" },
    { name: "Poori with Curry (2 pcs)", desc: "Puffed bread + potato curry", price: "$8.99" },
    { name: "Poori (1 pc)", desc: "Puffed, golden-fried", price: "$3.99" },
    { name: "Chole Bhatura", desc: "Spiced chickpeas + bhatura", price: "$12.99" },
    { name: "Bhatura (1 pc)", desc: "Pillowy fried bread", price: "$5.99" },
    { name: "Bread Basket", desc: "Plain / Butter / Garlic / Roti", price: "$17.99" },
  ],
  "south-indian": [
    { name: "Idly (3 pcs)", desc: "Steamed rice cakes, sambar & chutney", price: "$9.99" },
    { name: "Gun Powder Idly", desc: "Tossed in molagapodi", price: "$10.99" },
    { name: "Ghee Karam Idly", desc: "Ghee + spicy podi", price: "$10.99" },
    { name: "Sambar Idly", desc: "Drowned in sambar", price: "$10.99" },
    { name: "Kothu Paratha", desc: "Veg / Egg / Chicken / Lamb", price: "$14.99 / $15.99 / $16.99 / $17.99" },
  ],
  dosa: [
    { name: "Plain Dosa", desc: "Crisp golden crêpe", price: "$9.99" },
    { name: "Plain Dosa with Chicken Curry", desc: "Bone-in chicken curry side", price: "$16.99" },
    { name: "Plain Dosa with Goat Curry", desc: "Slow-cooked goat curry", price: "$18.99" },
    { name: "Kal Dosa", desc: "Soft skillet-style", price: "$10.99" },
    { name: "Ghee Dosa", desc: "Cooked in pure ghee", price: "$12.99" },
    { name: "Karam Podi Dosa", desc: "Lined with spicy podi", price: "$11.99" },
    { name: "Masala Dosa", desc: "Spiced potato filling", price: "$13.99" },
    { name: "Mysore Masala Dosa", desc: "Red chutney & masala", price: "$13.99" },
    { name: "Nellore Karam Dosa", desc: "Andhra-fiery podi", price: "$13.99" },
    { name: "Onion Dosa", desc: "Caramelised onion lace", price: "$13.99" },
    { name: "Egg Dosa", desc: "Topped with farm egg", price: "$14.99" },
    { name: "Rava Dosa", desc: "Lacy semolina crêpe", price: "$14.99" },
    { name: "Onion Rava Dosa", desc: "Rava + onion crunch", price: "$15.99" },
  ],
  "veg-main": [
    { name: "Paneer", desc: "Tikka Masala / Butter Masala / Chettinadu / Kadai / Saag", price: "$16.99" },
    { name: "Channa Masala", desc: "Punjabi chickpea curry", price: "$15.99" },
    { name: "Channa Saag", desc: "Chickpeas in spinach", price: "$15.99" },
    { name: "Baingan Bharta", desc: "Smoked mashed eggplant", price: "$16.99" },
    { name: "Gongura", desc: "Veg / Paneer in sorrel leaf", price: "$15.99 / $16.99" },
    { name: "Veg Vindaloo", desc: "Goan-style fiery curry", price: "$15.99" },
    { name: "Paneer Pasanda", desc: "Stuffed paneer, royal gravy", price: "$16.99" },
    { name: "Malai Kofta", desc: "Paneer dumplings, creamy sauce", price: "$16.99" },
    { name: "Gutti Vankaya", desc: "Stuffed baby eggplant", price: "$15.99" },
    { name: "Veg Diwani Handi", desc: "Mixed veg, royal masala", price: "$16.99" },
    { name: "Okra Cashew Fry (Dry)", desc: "Crisp bhindi + cashew", price: "$16.99" },
    { name: "Tindora Fry (Dry)", desc: "Ivy gourd, curry leaf", price: "$16.99" },
    { name: "Dal Makhani", desc: "Slow-cooked black lentils", price: "$15.99" },
    { name: "Dal Tadka", desc: "Tempered yellow dal", price: "$14.99" },
    { name: "Kadai Vegetables", desc: "Wok-tossed in kadai masala", price: "$14.99" },
    { name: "Aloo Gobi Masala", desc: "Potato + cauliflower curry", price: "$14.99" },
    { name: "Vegetable Kolhapuri", desc: "Maharashtrian spice blend", price: "$16.99" },
    { name: "Navarathna Kurma", desc: "Nine-veg royal curry", price: "$16.99" },
  ],
  "nonveg-main": [
    { name: "Egg", desc: "Masala / Chettinad", price: "$16.99" },
    { name: "Saag", desc: "Chicken / Lamb / Shrimp", price: "$16.99 / $19.99 / $19.99" },
    { name: "Tikka Masala", desc: "Chicken / Lamb / Shrimp", price: "$16.99 / $19.99 / $19.99" },
    { name: "Butter Masala", desc: "Chicken / Lamb", price: "$16.99 / $19.99" },
    { name: "Rogan Josh", desc: "Goat / Lamb", price: "$18.99 / $19.99" },
    { name: "Andhra Fish Pulusu", desc: "Tangy tamarind curry", price: "$19.99" },
    { name: "Malabar Curry", desc: "Fish / Shrimp in coconut", price: "$19.99 / $19.99" },
    { name: "Fish Tikka Masala", desc: "Tandoori fish, creamy gravy", price: "$19.99" },
    { name: "Vindaloo", desc: "Chicken / Goat / Lamb", price: "$16.99 / $18.99 / $19.99" },
    { name: "Curry", desc: "Chicken / Goat / Lamb", price: "$16.99 / $18.99 / $18.99" },
    { name: "Fish / Shrimp Curry", desc: "Coast-style spice", price: "$18.99 / $19.99" },
    { name: "Gongura", desc: "Chicken / Goat / Lamb", price: "$16.99 / $18.99 / $18.99" },
    { name: "Chettinad", desc: "Chicken / Goat / Lamb", price: "$16.99 / $18.99 / $18.99" },
    { name: "Kurma", desc: "Chicken / Goat / Lamb", price: "$16.99 / $18.99 / $18.99" },
    { name: "Andhra Chicken Curry", desc: "Bone-in, fiery red", price: "$17.99" },
  ],
  "indo-chinese": [
    { name: "Fried Rice", desc: "Veg / Gobi / Egg", price: "$14.99 / $15.99 / $15.99" },
    { name: "Fried Rice", desc: "Chicken / Shrimp", price: "$16.99 / $18.99" },
    { name: "Noodles", desc: "Veg / Gobi / Egg", price: "$14.99 / $15.99 / $15.99" },
    { name: "Noodles", desc: "Chicken / Shrimp", price: "$16.99 / $18.99" },
    { name: "Szechuan Rice", desc: "Veg / Gobi / Egg", price: "$15.99 / $16.99 / $16.99" },
    { name: "Szechuan Rice", desc: "Chicken / Shrimp", price: "$17.99 / $19.99" },
    { name: "Szechuan Noodles", desc: "Veg / Gobi / Egg", price: "$15.99 / $16.99 / $16.99" },
    { name: "Szechuan Noodles", desc: "Chicken / Shrimp", price: "$17.99 / $19.99" },
    { name: "Plain Rice", desc: "Steamed basmati", price: "$2.99" },
    { name: "Jeera Rice", desc: "Cumin-tempered rice", price: "$6.99" },
  ],
  biryanis: [
    { name: "Veg Biryani", desc: "Dum / Avakai / Gongura", price: "$15.99" },
    { name: "Paneer Biryani", desc: "Dum / Avakai / Gongura", price: "$16.99" },
    { name: "Egg Biryani", desc: "Dum / Avakai / Gongura", price: "$16.99" },
    { name: "Chicken Biryani", desc: "Dum / Avakai / Gongura", price: "$17.99" },
    { name: "Goat Biryani", desc: "Dum / Avakai / Gongura", price: "$19.99" },
    { name: "Lamb Biryani", desc: "Dum / Avakai / Gongura", price: "$19.99" },
    { name: "Fish Biryani", desc: "Dum / Avakai / Gongura", price: "$19.99" },
    { name: "Shrimp Biryani", desc: "Dum / Avakai / Gongura", price: "$20.99" },
    { name: "Red Chilly's Special Veg Biryani", desc: "House signature", price: "$16.99" },
    { name: "Gutti Vankaya Biryani", desc: "Stuffed eggplant style", price: "$16.99" },
    { name: "Red Chilly's Special Chicken Biryani", desc: "House signature", price: "$20.99" },
    { name: "Vijayawada Chicken Biryani", desc: "Andhra capital classic", price: "$18.99" },
    { name: "Chicken 65 Biryani", desc: "Fiery 65 layered", price: "$18.99" },
    { name: "Tawa Roast Biryani", desc: "Chicken / Goat / Lamb", price: "$17.99 / $19.99 / $19.99" },
  ],
  beverages: [
    { name: "Mango Lassi", desc: "Yogurt + Alphonso mango", price: "$4.99" },
    { name: "Rose Milk", desc: "Chilled rose-infused milk", price: "$5.99" },
    { name: "Lassi", desc: "Salt / Sweet", price: "$4.99" },
    { name: "South Indian Butter Milk", desc: "Spiced & tempered", price: "$4.99" },
    { name: "Lemon Soda", desc: "Salt / Sweet", price: "$4.99" },
    { name: "Iced Tea", desc: "Brewed & chilled", price: "$3.99" },
    { name: "Irani Chai", desc: "Available from 5 PM", price: "$4.99" },
    { name: "Masala Chai", desc: "House spice blend", price: "$3.99" },
    { name: "Madras Filter Coffee", desc: "Strong & frothy", price: "$3.99" },
    { name: "Thumbs Up / Limca / Frooti", desc: "Indian classics", price: "$4.99" },
    { name: "Goli Soda", desc: "Marble-bottled fizz", price: "$5.99" },
    { name: "Coke / Diet Coke / Sprite / Ginger Ale", desc: "Standard sodas", price: "$3.99" },
  ],
  desserts: [
    { name: "Gulab Jamun", desc: "Saffron-syrup soaked", price: "$5.99" },
    { name: "Rasmalai", desc: "Cardamom milk soaked", price: "$5.99" },
    { name: "Carrot Halwa", desc: "Slow-cooked gajar halwa", price: "$5.99" },
    { name: "Kulfi", desc: "Traditional Indian ice cream", price: "$5.99" },
    { name: "Gulab Jamun with Ice Cream", desc: "Warm + cold combo", price: "$8.99" },
    { name: "Carrot Halwa with Ice Cream", desc: "Classic pairing", price: "$9.99" },
    { name: "Sizzling Chocolate Brownie Sundae", desc: "Hot brownie + ice cream", price: "$10.99" },
  ],
};
